import React, { useEffect, useState } from "react";
import translate from "../../../i18n/translate";
import "./CultureCentre.scss";
import allActions from "../../../redux/actions";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { CircularProgress, Container } from "@material-ui/core";
import ProductivityToolsDescriptionContainer from "../../shared/ProductivityToolsDescriptionContainer/ProductivityToolsDescriptionContainer";
import { getRandomNumber } from "../../shared/utils/sharedUtils";

const CultureCentre: React.FC = () => {
  const [cultureCentreFeatureEnabled, setCultureCentreFeatureEnabled] = useState(false);
  const [loaderFlag, setLoaderFlag] = useState<boolean>(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const allInfo = useSelector((state: any) => state);

  useEffect(() => {
    dispatch(allActions.cultureCentreAction.getCountriesList());
  }, []);

  useEffect(() => {
    if (allInfo.peopleInformation.data && allInfo.cultureCentreCountries.data) {
      const isCultureCentreEnabled =
        allInfo.peopleInformation.data?.getpeopleInformation?.serviceConfiguration?.features.substring(27, 28) === "1";
      if (isCultureCentreEnabled) setCultureCentreFeatureEnabled(true);
      else setCultureCentreFeatureEnabled(false);
      setLoaderFlag(false);
    }
    if (allInfo.peopleInformation.isFailed || allInfo.cultureCentreCountries.isFailed) setLoaderFlag(false);
  }, [allInfo.peopleInformation, allInfo.cultureCentreCountries]);

  const handleChangeValue = (countryCode: any) => {
    dispatch(allActions.commonActions.setSelectedCountry(countryCode));
    navigate(`/culturecenter/${countryCode.toLowerCase()}`);
  };

  return (
    <div className="culturecenter">
      <Container>
        {!loaderFlag ? (
          <React.Fragment>
            {allInfo.cultureCentreCountries.data && allInfo.peopleInformation.data ? (
              <React.Fragment>
                {cultureCentreFeatureEnabled ? (
                  <div data-testid="culturecenter-container" className="culturecenter-container">
                    <ProductivityToolsDescriptionContainer
                      headingTitle="feature_culture_centre_title"
                      featureDescription="feature_cultureCentre_desc"
                      featureImg={window.location.origin + "/images/" + "Feature_Illustrations/Culture-notes.svg"}
                    />
                    <div className="culturecenter-disclaimer" data-testid="culturecenter-disclaimer">
                      <h6 className="culturecenter-disclaimer-title">{translate("culurecenter_disclaimer_title")}:</h6>
                      <p className="culturecenter-disclaimer-desc">{translate("culturecenter_disclaimer")}</p>
                    </div>
                    <h5>{translate("SAR")}</h5>
                    <div className="culturecenter-flags">
                      {allInfo.cultureCentreCountries.data.map((element: any, index: number) => {
                        return (
                          <button
                            key={getRandomNumber(index)}
                            className="remove-button-default-style"
                            onClick={() => handleChangeValue(element.code)}
                          >
                            <div className="culturecenter-flags-individual" data-testid="culturecenter-flag">
                              <div className="culturecenter-flags-individual-img">
                                <img className="culcen-image-wrap" src={element.flag} alt="" />
                              </div>
                              <div className="culturecenter-flags-individual-title">{element.name}</div>
                            </div>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <div className="culturecenter-errorpage">
                    <ErrorPage status={401} />
                  </div>
                )}
              </React.Fragment>
            ) : (
              <></>
            )}
          </React.Fragment>
        ) : (
          <div data-testid="culturecenter-loader" className="culturecenter-loader-container">
            <CircularProgress size={50} color="primary" />
          </div>
        )}
      </Container>
    </div>
  );
};

export default CultureCentre;
